import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import { Button } from "@/components/ui/button";
import { getConsent, setConsent, OPEN_COOKIE_EVENT } from "@/lib/cookies";

export function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!getConsent()) setVisible(true);
    const open = () => setVisible(true);
    window.addEventListener(OPEN_COOKIE_EVENT, open);
    return () => window.removeEventListener(OPEN_COOKIE_EVENT, open);
  }, []);

  const decide = (value) => {
    setConsent(value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-20 left-4 right-4 sm:left-auto sm:right-6 sm:bottom-6 z-[100] sm:max-w-sm"
    >
      <div className="bg-foreground text-background border border-foreground shadow-2xl p-5 flex flex-col gap-4 animate-in slide-in-from-bottom-4 fade-in duration-300">
        <div className="flex items-start gap-3">
          <Cookie className="w-5 h-5 shrink-0 mt-0.5 text-background/80" />
          <div>
            <p className="font-heading font-bold text-sm leading-tight">Cookies en News Digest</p>
            <p className="text-xs text-background/70 mt-1.5 leading-relaxed">
              Usamos cookies para el funcionamiento del sitio. Puedes aceptarlas o rechazarlas.
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          <Button
            data-testid="cookie-reject-button"
            variant="outline"
            onClick={() => decide("rejected")}
            className="rounded-none flex-1 h-9 text-xs bg-transparent border-background/40 text-background hover:bg-background/10 hover:text-background"
          >
            Rechazar
          </Button>
          <Button
            data-testid="cookie-accept-button"
            onClick={() => decide("accepted")}
            className="rounded-none flex-1 h-9 text-xs bg-primary hover:bg-blue-900 text-white border-0"
          >
            Aceptar
          </Button>
        </div>
      </div>
    </div>
  );
}
